export type OptionType = {
  label?: string;
  id: string;
  name: string;
  localName?: string;
  displayName?: string;
  title?: string;
  value?: string | number;
};

export enum MailHistoryType {
  MANUAL = 'Manual',
  AUTOMATIC = 'Automatic',
  CUSTOM = 'Custom',
}
export type selectedCandidate = {
  clientOrganizationId: string;
  configurationId: string;
  userId: string;
  applicationId: string;
};
export type bulkMailPayload = {
  selectedCandidates: selectedCandidate[];
  ruleType: MailHistoryType;
  mailTemplateId: string;
  id: string;
  mailSubject?: string;
  mailBody?: string;
};

export enum bulkMailStatus {
  INITIATED = 'initiated',
  INPROGRESS = 'in_progress',
  SENTTOALL = 'sent_to_all',
  PARTIALLYFAILED = 'partially_failed',
  ALLFAILED = 'all_failed',
}

export const MAILBODY_MAX_CHAR = 120;

export const mailPlaceholders = [
  { key: '%first_name%', desc: 'first_name_description' },
  { key: '%last_name%', desc: 'last_name_description' },
  { key: '%login_link%', desc: 'login_link_description' },
];

export enum MailNotificationsType {
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  NONE = 'NONE',
}
